import { Pill } from "@/components/pill/Pill";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import type { QuestionFormType } from "@/types/types";
import Detail from "./questions-table/Detail";

const ChecklistDetails = ({ checklist }: { checklist: QuestionFormType }) => {
  const translate = useTranslate();
  return (
    <div className="flex space-x-6 ">
      <div className="flex items-center">
        <div className="">
          {checklist.lastVersion ? (
            <Pill label={translate("on")} className="bg-[#ADE1C7]" />
          ) : (
            <Pill label={translate("off")} className="bg-ib-gray-borders" />
          )}
        </div>
      </div>

      <div className="border" />
      <div className="flex space-x-8">
        <Detail label={translate("engine")} value={checklist.type} />
        <Detail label={translate("tasks")} value={checklist.questions.length} />
        <Detail
          label={translate("lastUpdate")}
          value={new Date(checklist.createdAt).toLocaleString()}
        />
      </div>
    </div>
  );
};

export default ChecklistDetails;
